/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect} from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {Grid, Stack} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import EmptyContent from '@components/empty-content/empty-content';
import CustomBreadcrumbs from 'src/minimal-components/custom-breadcrumbs/custom-breadcrumbs';
import SupersetComponent from '../../superset/SupersetComponent';
import {useNavigate} from 'react-router-dom';
import {environment} from '@shared/config/environment';

const MarketPlaceComponent = (props: any): React.ReactElement => {
  const {t} = useTranslation();
  const {CustomBreadcrumbsHeading} = props;
  const [loadExternalUrl, setLoadExternalUrlExternalUrl] =
    React.useState<boolean>(false);
  const [externalUrl, setExternalUrl] = React.useState<string>('');
  const [selectedLink, setSelectedLink] = React.useState<string | null>(null);
  const navigate = useNavigate();

  const isReflectActive = environment?.IsReflectActive;

  const data = [
    {
      id: 1,
      heading: 'Patient Care Link',
      description:
        // eslint-disable-next-line max-len
        'Patient Care Link enable all interactions - reminders, exchange of insurance information, payments and statements – with a simple but interconnected text messages.',
      link: 'http://staging.pcarelink.com/'
    },
    {
      id: 2,
      heading: 'BI Tool',
      description:
        'Integrate with Reflect to generate reports, create dashboards and analyze your data.',
      link: '/bytepad/module/bi-tool'
    }
  ];

  const renderSearchButton = (link: string, heading: string) => {
    const isBiTool = link === '/bytepad/module/bi-tool';
    const isBiToolActive = isBiTool && isReflectActive;

    return (
      <LoadingButton
        type="submit"
        variant="contained"
        onClick={() => {
          setLoadExternalUrlExternalUrl(true);
          setExternalUrl(link);
          setSelectedLink(heading);
        }}
        sx={{
          backgroundColor: isBiToolActive ? 'green' : undefined,
          '&:hover': {
            backgroundColor: isBiToolActive ? 'darkgreen' : undefined
          }
        }}
        disabled={isBiTool && !isReflectActive} // Disable button if it's BI Tool and Reflect is not active
      >
        {isBiToolActive
          ? 'Activated'
          : t('PRIVATE.COMMON.INTEGRATE', {ns: 'private'})}
      </LoadingButton>
    );
  };

  useEffect(() => {
    if (externalUrl === '/bytepad/module/bi-tool') {
      navigate('/bytepad/module/bi-tool');
    }
  }, [externalUrl, navigate]);

  const clearExternalUrl = () => {
    setLoadExternalUrlExternalUrl(false);
    setExternalUrl('');
    setSelectedLink(null);
  };

  return (
    <Stack>
      {loadExternalUrl &&
      externalUrl &&
      externalUrl !== '/bytepad/module/bi-tool' ? (
        <>
          <CustomBreadcrumbs
            links={
              selectedLink
                ? [
                    {
                      name: CustomBreadcrumbsHeading,
                      href: '/bytepad/module/marketplace',
                      onClick: clearExternalUrl
                    },
                    {name: selectedLink}
                  ]
                : []
            }
            sx={{
              my: 2
            }}
          />
          <iframe
            src={externalUrl}
            style={{height: '90vh', border: '0', width: '100%'}}
            loading="eager"
          />
        </>
      ) : loadExternalUrl ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <EmptyContent title="No results found" />
        </Stack>
      ) : (
        <Grid
          container
          direction={'column'}
          spacing={{xs: 2}}
          style={{margin: 1}}>
          {!externalUrl && (
            <CustomBreadcrumbs
              heading={CustomBreadcrumbsHeading}
              sx={{
                mt: 2
              }}
            />
          )}
          <Grid container spacing={{xs: 2}} style={{margin: 1}}>
            {data.map((item: any) => (
              <Grid item xs={4} key={item.id}>
                <Card>
                  <CardContent style={{height: '8rem'}}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      color={'#000000'}>
                      {item.heading}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{minBlockSize: 40}}>
                      {item.description}
                    </Typography>
                  </CardContent>
                  <CardActions style={{justifyContent: 'end', padding: '16px'}}>
                    {renderSearchButton(item.link, item.heading)}
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </Stack>
  );
};
export default MarketPlaceComponent;

